import { Component, OnInit,ViewChild } from '@angular/core';
import swal from 'sweetalert2';  
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { exit } from 'process';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
@Component({
  selector: 'app-hk',
  templateUrl: './hk.component.html',
  styleUrls: ['./hk.component.scss']
})
export class HkComponent implements OnInit {
  @ViewChild('closebutton1', {static: false}) closebutton1; 
  @ViewChild('closebuttonevl', {static: false}) closebuttonevl; 
  @ViewChild('cpa2', {static: false}) cpa2;  
  @ViewChild('cpa22', {static: false}) cpa22;  

  constructor(
    public authService: AuthService,public router: Router) { }
  id_cliente;
  id_usuario;
  ngOnInit() {
    this.loading=true;
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    this.id_usuario=Number(localStorage.getItem("usuario"));
    //this.get_org();
    this.ls_hk();
    this.bnd_list=true;
    this.loading=false;
  }
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
  bnd5hk:boolean=false;
  org2_=[];
  org3_=[];
  niv_=[];
  ls_chk="";
  tot_Sel:Number=0;
  ch_id_evtg(id,d){
    var a=this.ls_chk.split(",");
    if(a.length>0){      
      //console.log(a);
      if(a.indexOf(id.toString())==-1){
        if (a[0]==""){
          a[0]=id.toString();
        }else{
          a.push(id.toString());
        }
      }else{               
        var i = a.indexOf(id.toString()); 
        a.splice( i, 1 );
      }
      this.ls_chk=a.toString();
    }else{
      this.ls_chk=id.toString();
    }
    this.tot_Sel= a.length;
  }
  id_resp=0;
  tx_ant="";
  selusu2(id){ 
    console.log("selusu")
    console.log(id);
    
    console.log(this.org);
    this.org2_=[]
    this.ls_chk="";
    if(id==0){      
      return;
    }   
    var j=0;
 
    for(let i=0;i<this.org.length;i++){
      if(this.org[i].idarea1==id ){
        if(j>0){
          this.ls_chk=this.ls_chk+",";
        }
        this.ls_chk=this.ls_chk+this.org[i].id;
        this.org2_.push(this.org[i]);
        j++;
      }
    }
   
    
  }

  selusu1(id,tx){     
    this.duenio_id1=tx.target.options[tx.target.options.selectedIndex].value;
    this.org2_=[]
    this.ls_chk="";
    if(id==0){      
      return;
    }   
    this.duenio=tx.target.options[tx.target.options.selectedIndex].text;
    this.id_resp=id;
    
    var j=0;    
    //console.log(id);
    for(let i=0;i<this.org3_.length;i++){
      //if(this.org[i].idarea1==id ){
        //console.log(this.org[i]);
        if(j>0){
          this.ls_chk=this.ls_chk+",";
        }
        this.ls_chk=this.ls_chk+this.org3_[i].id;
        this.org2_.push(this.org3_[i]);
        j++;
     // }
    }    
    this.fn_nivel(this.nivel);
  }
  selusu(id,tx){ 
    this.duenio_id=id;
    this.org2_=[]
    this.ls_chk="";
    if(id==0){      
      return;
    }   
    this.duenio=tx.target.options[tx.target.options.selectedIndex].text;
    this.id_resp=id;
    
    var j=0;    
    //console.log(id);
    for(let i=0;i<this.org.length;i++){
      //if(this.org[i].idarea1==id ){
        //console.log(this.org[i]);
        if(j>0){
          this.ls_chk=this.ls_chk+",";
        }
        this.ls_chk=this.ls_chk+this.org[i].id;
        this.org2_.push(this.org[i]);
        j++;
     // }
    }
    console.log("org2_",this.org2_)
    this.fn_nivel(this.nivel);
    
  }
  responsable=0;
  _superv(sp){
    if(this.duenio_id==0)swal.fire('¡Please select a Responsible!', '', 'warning');
    let postData = {
      nivel:this.nivel,
      id_hk:this.id_hk,
      responsable:this.duenio_id,
      supervisor:sp    
    }
    //console.log(postData);
    this.authService.service("/api/upd_supervhk",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });
  }
  fechk="";
  datehk(){ 
    if(this.duenio_id==0)swal.fire('¡Please select a Responsible!', '', 'warning');
    let postData = {
      nivel:this.nivel,
      id_hk:this.id_hk,
      responsable:this.duenio_id,
      fecha:this.fechk     
    }
    //console.log(postData);
    this.authService.service("/api/upd_fechk",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  

        swal.fire('¡ok', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });

  }
  gda_responsables(id){
    let postData = {
      nivel:this.nivel,      
      id_hk:this.id_hk,
      responsable:id    
    }
    //console.log(postData);
    this.authService.service("/api/gda_hkresp",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.ls_responsablel()

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });
  }
  fn_hk51(){
    this.bnd5hk=true
    //console.log (this.org2_)
    console.log( "nivel",this.nivel)
  }

  fn_hk5(){
    this.bnd5hk=true
    this.org3_=[]
    this.duenio_id1 = 0;
    
    var iniv1 = Number(this.nivel);
    var iniv2 = Number(this.nivel);
    iniv2 = iniv2 + 1;

    this.authService.service("/api/get_org_role_niv1",{ id_cliente:localStorage.getItem("id_cliente"),nivel1:iniv1,nivel2:iniv2} )
    .then(
    data => {
      console.log("get_org_role_niv1",data)
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);  
        this.org3_=data;                       
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de);
        swal.fire('¡API incorrecta!', '', 'error');        
    }); 
  }

  evl_name;
  Sup=[];
  LI=[];
  LD=[];
  Inf=[];
  Resp=[];
  si_id=[]
  bnd_list:boolean=false;
  hk_list=[];
 
  ls_hk(){
    let postData = {
      id_cliente:this.id_cliente,    
    }
    //console.log(postData);
    this.authService.service("/api/get_hk",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.hk_list=res;

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });  
  }
  org;
  org_=[];
  org_head(){ 
    this.org_=[];
    console.log(this.nivel)    
    switch (Number(this.nivel)) {
      case 1:
          var bnd=0;          
          for(var i=0;i<this.org.length;i++){
            if(this.org[i].director==1){
              if(bnd==0){
                this.org_.push(this.org[i]);  
                this.duenio_id_n1= this.org[i].id_role;   
                bnd=1;
              }
            }
            
          }       
        break;    
      default:        
        for(var i=0;i<this.evl.length;i++){
          if(Number(this.evl[i].lado)==5 && this.evl[i].nivel==(this.nivel-1)){
            for(var j=0;j<this.org.length;j++){
              if(this.evl[i].id_ant==this.org[j].id){
                this.org_.push(this.org[j]); 
              }
            }
          }
          
        } 
        break;
    }   
   
       
  }

  get_org(){
    this.org=[];
    this.org2_=[]
    this.ls_chk="";
    this.authService.service("/api/get_org_role_niv",{ id_cliente:localStorage.getItem("id_cliente"),nivel:this.nivel} )
    .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);  
        this.org=data;                 
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de);
        swal.fire('¡API incorrecta!', '', 'error');        
    }); 
  }

  get_org1(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //console.log(postData);
      this.authService.service("/api/get_org",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.org=data;
            console.log(data);
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
  
  id_hk;
  hk_name;
  hkt;
  fn_jk;
  del_hk(itm){
    //console.log(itm);
    this.id_evl=itm.id;
    this.lado_hk=itm.lado;
    if(confirm("Confirm to delete this record?")==false)return;
    let postData = {
      id:itm.id,    
    }
    //console.log(postData);
    this.authService.service("/api/del_hkevl",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.delete_hk(); 
        this.closebuttonevl.nativeElement.click();
        swal.fire('Ok', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });

  }
  lvl1="btn-primary";
  lvl2="btn-secondary";
  lvl3="btn-secondary";
  nivel=1;
  upd_niv(){
    if(this.nivel>=2){    
      let postData = {      
        id:this.id_hk
      }
      //sp_nniv2
      //console.log("niv--");//upd_niv2_usu
      console.log(postData);
      this.authService.service("/api/upd_niv"+this.nivel+"_usu",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);      
          /*
          this.lsevl_hk();
          this.duenio_id=0;
          this.Inf=[];
          this.Sup=[];
          this.LI=[];
          this.LD=[];
          this.Resp=[];
          */
          let postData = {
            id_hk:this.id_hk,  
            nivel:this.nivel  
          }
          this.authService.service("/api/getevl_hk",postData)
          .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);  
              this.evl=res
              this.fn_nivel(this.nivel);
            });
          
          swal.fire('Ok', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });
    }    
    
  }
  sel_nivel(n){
    this.nivel=n;      
    this.get_org();      
    this.org_head();    
    this.duenio_id=this.duenio_id_n1;
    
    /*
    this.fn_nivel(n);
    if(n==1){
      try {        
        this.duenio_id=this.duenio_id_n1;
        this.fn_nivel(n);
      } catch (error) {}
    }else{
      this.duenio_id=0;
      this.Resp=[];  
      this.Inf=[];
      this.Sup=[];
      this.LI=[];
      this.LD=[];
    }*/
  }
  async fn_nivel(n){
    this.LD=[];this.LI=[];
    this.Sup=[];this.Inf=[];this.Resp=[];
    this.nivel=n;     
    
    console.log("this.evl",this.evl)

    switch (Number(n)) {
      default:        
        
        for(var i=0;i<this.evl.length;i++){
          
          //console.log(this.evl.length)
          //console.log(this[i]);
          
          if(Number(this.evl[i].lado)==1){
            if(this.evl[i].nivel==this.nivel)
            this.Sup.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
          }
          if(Number(this.evl[i].lado)==2){
            if(this.evl[i].nivel==this.nivel)
            this.LD.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
          }
          if(Number(this.evl[i].lado)==3){
            if(this.evl[i].nivel==this.nivel)
            this.Inf.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
          }
          if(Number(this.evl[i].lado)==4){
            if(this.evl[i].nivel==this.nivel)
            this.LI.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
          }
          if(Number(this.evl[i].lado)==5){
            if(this.evl[i].nivel==this.nivel)
            //Revisar
            //this.Resp.push({des:this.evl[i].persona,id:this.evl[i].id,lado:this.evl[i].lado});
            //this.Resp.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});

            
            if (this.evl[i].nombre != ""){
              this.Resp.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
            }else{
              var nom = await this.get_nombre1(this.evl[i].id_ant);
              this.Resp.push({des:nom,id:this.evl[i].id,lado:this.evl[i].lado});
            }
            


            
            

          }
        }     
        break;
      //default:        
      case 111:        
      //console.log("dueño "+this.duenio_id);
        for(var i=0;i<this.evl.length;i++){
          if(Number(this.evl[i].lado)==1){
            if(this.evl[i].nivel==this.nivel)
            if( Number(this.evl[i].responsable)==Number(this.duenio_id))
            this.Sup.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
          }
          if(Number(this.evl[i].lado)==2){
            if(this.evl[i].nivel==this.nivel)
            if( Number(this.evl[i].responsable)==Number(this.duenio_id))
            this.LD.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
          }
          if(Number(this.evl[i].lado)==3){
            if(this.evl[i].nivel==this.nivel)
            if( Number(this.evl[i].responsable)==Number(this.duenio_id))
            this.Inf.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
          }
          if(Number(this.evl[i].lado)==4){
            if(this.evl[i].nivel==this.nivel)
            if( Number(this.evl[i].responsable)==Number(this.duenio_id))
            this.LI.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
          }
          if(Number(this.evl[i].lado)==5){
            //console.log(this.evl[i]);
            if(Number(this.evl[i].nivel)==this.nivel){              
              if( Number(this.evl[i].responsable)==Number(this.duenio_id)){              
              //console.log("ok"+this.evl[i].id);
              this.Resp.push({des:this.evl[i].persona,id:this.evl[i].id,lado:this.evl[i].lado});
              }
            }
            
          }
        }
        break;
    }
    this.bnd_list=false;  
    this.hk_v=true;
  }
  public loading;
  delete_hk(){
    var aux=[];
    for(var i=0;i<this.evl.length;i++){
      if(this.evl[i].id!=this.id_evl){            
        aux.push(this.evl[i]);
      }
    }
    this.evl=aux;
    aux=[];
    switch (Number(this.lado_hk)) {
      case 1:
        for(var i=0;i<this.Sup.length;i++){
          if(this.Sup[i].id!=this.id_evl){            
            aux.push(this.Sup[i]);    
          }          
        } 
        this.Sup=aux; 
      break;
      case 2:
        for(var i=0;i<this.LD.length;i++){
          if(this.LD[i].id!=this.id_evl){
            aux.push(this.LD[i]);    
          }          
        } 
        this.LD=aux;           
      break;
      case 3:
        for(var i=0;i<this.Inf.length;i++){
          if(this.Inf[i].id!=this.id_evl){
            aux.push(this.Inf[i]);    
          }          
        } 
        this.Inf=aux;           
      break;
      case 4:
        for(var i=0;i<this.LI.length;i++){
          if(this.LI[i].id!=this.id_evl){
            aux.push(this.LI[i]);    
          }          
        } 
        this.LI=aux;           
      break;      
      case 5:
        for(var i=0;i<this.Resp.length;i++){
          if(this.Resp[i].id!=this.id_evl){
            aux.push(this.Resp[i]);    
          }          
        } 
        this.Resp=aux;                   
      break;
        
      }
  }
  upd_arl(){
    //console.log(this.lado_hk);
    switch (Number(this.lado_hk)) {
      case 1:
        for(var i=0;i<this.Sup.length;i++){
          if(this.Sup[i].id==this.id_evl){
            this.Sup[i].des=this.evl_name;
          }
        }  
      break;
      case 2:
        //console.log(this.LD)
        //console.log(this.id_evl)
        //console.log(this.evl_name)
        for(var i=0;i<this.LD.length;i++){
          if(this.LD[i].id==this.id_evl){
            this.LD[i].des=this.evl_name;
          }
        }  
      break;
      case 3:
        for(var i=0;i<this.Inf.length;i++){
          if(this.Inf[i].id==this.id_evl){
            this.Inf[i].des=this.evl_name;
          }
        }  
      break;
      case 4:
        for(var i=0;i<this.LI.length;i++){
          if(this.LI[i].id==this.id_evl){
            this.LI[i].des=this.evl_name;
          }
        }  
      break;      
      case 5:
        for(var i=0;i<this.Resp.length;i++){
          if(this.Resp[i].id==this.id_evl){
            this.Resp[i].des=this.evl_name;
          }
        }  
      break;
        
    
      default:
        break;
    }
  }
  edt_hk(itm){
    //console.log(itm)
    this.id_hk=itm.id;
    this.hk_name=itm.nombre;
    this.bndv_raci=false
  }
  dupl_hk(itm){
    let postData = {
      id:itm.id,    
    }
    //console.log(postData);
      this.authService.service("/api/dupl_hk",postData)
      .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.ls_hk();
        this.closebutton1.nativeElement.click();    
        swal.fire('Ok', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });

  }
  
  upd_evl(){
    let postData = {
      id:this.id_evl,
      nombre:this.evl_name, 
      nivel:this.nivel   
    }
    //console.log(postData)
      this.authService.service("/api/upd_hkevl",postData)
      .then(
      data => {
        this.upd_arl()
        this.closebuttonevl.nativeElement.click();
        swal.fire('Ok', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });  
  }
  id_evl=0;
  n_raci(){
    this.bndv_raci=true;
    
  }
  duenio;
  chart(){
    
  }
  n_niv(){
    this.niveles=this.niveles+1;
    if(this.niveles==2){
      this.niv_.push({nivel:this.niveles})
      let postData = {
        id:this.id_hk,
        nivel:this.niveles
      }
      //console.log(postData)
        this.authService.service("/api/upd_nivhk2",postData)
        .then(
        data => {
          this.ls_hk();
          this.lsevl_hk();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });
    }       
  }
  d_niv(){
    this.niveles=this.niveles-1;
    //console.log(this.niveles);   
    this.niv_.pop();
    let postData = {
      id:this.id_hk,
      nivel:this.niveles
    }
    //console.log(postData)
      this.authService.service("/api/upd_nivhk",postData)
      .then(
      data => {
        this.ls_hk();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });
  }
  upd_proceso(itm){
    //console.log(itm);
    this.bndv_raci=false;
    this.evl_name=itm.des;
    this.lado_hk=itm.lado;
    this.id_evl=itm.id;
    if(itm.lado==5){
      this.bnd5hk=true;
    }else{
      this.bnd5hk=false;
    }
  }
  niveles=0;
  responsables;
  duenio_id=0;
  duenio_id1=0;
  superv=0;
  get_duenio(){
    //console.log(this.responsables);
    this.duenio="";
    for(var i=0;i< this.responsables.length;i++){
      if(this.responsables[i].nivel==this.nivel){
        //console.log(this.responsables[i])
        this.duenio=this.responsables[i].titulo;
        this.duenio_id=this.responsables[i].responsable;
        this.fechk=this.responsables[i].fecha.substring(0,10);
        this.superv=this.responsables[i].supervisor;
      }
    }
  }
  ls_responsablel(){
    this.responsables=[];        
    let postData = {
      id_hk:this.id_hk,
      nivel:this.niveles
    }
    //console.log(postData)
      this.authService.service("/api/get_hkresp",postData)
      .then(
      data => {
        this.responsables=data;
        
        this.get_duenio();
        console.log(data);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });
  }
  duenio_id_n1=0;
  async v_hk(itm){
    this.Sup=[];
    this.Resp=[];
    this.LI=[];
    this.LD=[];
    this.Inf=[];    
    this.niv_=[];
    this.niveles=itm.nivel;
    this.bnd_list=false;  
    this.hk_v=true;  
    this.id_hk=itm.id;
    console.log("id_hk");
    console.log(this.id_hk);
    this.hkt=itm.nombre;

    await this.lsevl_hk();   
    await this.lsr_hk();   
    await this.ls_responsablel();
    for(var i=0;i<this.responsables.length;i++){
      if(this.responsables[0].nivel==1){
        this.duenio_id_n1=this.responsables[0].responsable;
      }
    }
    this.nivel=0;
  }
  evl;
  lsevl_hk(){/**/
    let postData = {
      id_hk:this.id_hk,  
      nivel:this.nivel  
    }
    this.authService.service("/api/getevl_hk",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.evl=res
        //console.log(res);
        //console.log(res.length);   
           
        
        //console.log(this.Sup);
        //console.log(this.LD);
        //console.log(this.LI);
        //console.log(this.Inf);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  bndv_raci:Boolean=true;
  lado_hk=0;
  n_evl(l){
    //console.log(l);
    this.bndv_raci=true;
    if(l==5){
      //this.selusu2(this.duenio_id);
      this.bnd5hk=true;
    }else{
      this.bnd5hk=false;
    }
    this.bnd5hk=false;
    this.lado_hk=l;
    this.evl_name="";
  }
  _e;
  _si;
  _id;
  v_(e,si,id){
    //console.log(e+"-"+si+"-"+id)
    this._e=e;
    this._si=si;
    this._id=id;
    this.type_hk=this.check_pa(5,si,id);
  }
  type_hk;
  get_nombre(id){
    //console.log(this.org2_);
    //console.log(id);
    for(var i=0;i<this.org2_.length;i++){
      if(this.org2_[i].id==id){
        return this.org2_[i].persona;
      }
    }
  }

  async get_nombre1(id){
    var nom; 
    let postData = {id_role:id }                         
    await this.authService.service("/api/get_persona_id_role",postData)
    .then(
        data => {               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                                  
          //nom =res[0].nombre+" "+res[0].apaterno+" "+res[0].amaterno;   
          nom =res[0].puesto;                                      
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! reportto', '', 'error');
        });  
        return nom;    
    
  }

  id_ant;
  async gda_evl(){
    this.loading=true;
    if (this.bnd5hk==true){      
      this.gda_responsables(this.id_resp);
      this.duenio=this.tx_ant;
      if(this.ls_chk=="")return;
      var a =this.ls_chk.split(",");            

      if (a.length>0){
        //for(var i=0;i<a.length;i++){
        for(var i=0;i<1;i++){          
          if (this.duenio_id1 ==0){            
            this.loading=false;
            return;
          }

          let postData = {
            id_hk:this.id_hk,
            lado:this.lado_hk, 
            nombre:this.evl_name,    
            //id_ant:a[i],
            id_ant:this.duenio_id1,            
            nivel:this.nivel,            
            responsable:this.duenio_id
          }
            this.id_ant=this.duenio_id1;          
            await this.authService.service("/api/gda_hkevl",postData)
            .then(
            data => {             
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat); 
              
              var objIndex = this.org3_.findIndex(((itm1 :any) => itm1.id_role == this.duenio_id1));    
              var nom = this.org3_[objIndex].persona
              
              //console.log(data.insertId)              
              this.evl.push({nombre:nom,lado:this.lado_hk,id:data.insertId,nivel:this.nivel,responsable:this.duenio_id});        
              switch (this.lado_hk) {                
               case 5:
                  this.Resp.push({des:nom,lado:this.lado_hk,id:data.insertId,responsable:this.duenio_id});                  
                  break;
              }
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡Información incorrecta!', '', 'error');
                this.loading=false;
            });
            this.loading=false;
            
            this.closebuttonevl.nativeElement.click();        
            
        }
      }
    }else{    
    let postData = {
      id_hk:this.id_hk,
      lado:this.lado_hk, 
      nombre:this.evl_name,  
      id_ant:0 ,      
      nivel:this.nivel,
      responsable:this.duenio_id
    }
    //console.log(postData)
      this.authService.service("/api/gda_hkevl",postData)
      .then(
      data => {
        //console.log(data.insertId)
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        //console.log(res.insertId);
        this.evl.push({nombre:this.evl_name,lado:this.lado_hk,id:res.insertId,nivel:this.nivel,responsable:this.duenio_id});        
        switch (this.lado_hk) {
          case 1:
            this.Sup.push({des:this.evl_name,lado:this.lado_hk,id:res.insertId,responsable:this.duenio_id});
            break;
         case 2:
            this.LD.push({des:this.evl_name,lado:this.lado_hk,id:res.insertId,responsable:this.duenio_id});
            break;
         case 3:
            this.Inf.push({des:this.evl_name,lado:this.lado_hk,id:res.insertId,responsable:this.duenio_id});
            break;
         case 4:
            this.LI.push({des:this.evl_name,lado:this.lado_hk,id:res.insertId,responsable:this.duenio_id});
            break;
         case 5:
            this.Resp.push({des:this.evl_name,lado:this.lado_hk,id:res.insertId,responsable:this.duenio_id});
            break;        
          default:
            break;
        }
        this.closebuttonevl.nativeElement.click();        
        //swal.fire('Ok', '', 'success');
        this.loading=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!'+di, '', 'error');
          this.loading=false;
      });   
      this.loading=false;
    }
    this.loading=false;
  }

  del_hk_ls(itm){
    if(confirm("Confirm to delete this record?")==false)return;
    let postData = {
      id:itm.id,    
    }
    //console.log(postData);
      this.authService.service("/api/del_hk",postData)
      .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.ls_hk();
        this.closebutton1.nativeElement.click();    
        swal.fire('Ok', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });
  }
  upd_raci(){
    let postData = {
      id:this.id_hk,
      nombre:this.hk_name,    
    }
      this.authService.service("/api/upd_hk",postData)
      .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.ls_hk();
        this.closebutton1.nativeElement.click();    
        swal.fire('Ok', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });   
  }
  gda_raci(){
    let postData = {
      id_cliente:this.id_cliente,
      id_usuario:this.id_usuario,
      nombre:this.hk_name,    
    }
      this.authService.service("/api/gda_hk",postData)
      .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.ls_hk();
        this.closebutton1.nativeElement.click();    
        swal.fire('Ok', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });   
  }
  lsr_hk(){
    let postData = {
      id_hk:this.id_hk,
      nivel:this.nivel
    }
    //console.log(postData);
      this.authService.service("/api/get_r_hk",postData)
      .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        //console.log(data);
        this.si_id=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });     
  }
  togle_raci_list(){
    if(this.bnd_list==true){
      this.bnd_list=false
    }else{
      this.bnd_list=true;
    }
  }
  check_pa2(e,si,id){
    var val="";
    var bndc=false;
    //console.log("fn check e:"+e+"-si:"+si+"-id:"+id);
    //console.log(this.si_id)    
    for(var i=0;i<this.si_id.length;i++){
      if(this.si_id[i].e==e && this.si_id[i]._si==si && this.si_id[i]._id==id){
        var valor = "";
        if (this.si_id[i].valor == "Rs") valor = "S";
        else valor = this.si_id[i].valor;
        val="<div class='"+this.si_id[i].valor+"'>"+valor+"</div>";
        if(this.si_id[i].c==1)bndc=true;
      }
    }
    if(e==5){
      return val;
    }
    if(bndc==true){
      return true;
    }else{
      return false;
    }    
  }
  check_pa(e,si,id){
    var val="";
    var bndc=false;
    //console.log("fn check e:"+e+"-si:"+si+"-id:"+id);
    //console.log(this.si_id)    
    for(var i=0;i<this.si_id.length;i++){      
      if(this.nivel==1){
        if(this.si_id[i].e==e && this.si_id[i]._si==si && this.si_id[i]._id==id){
          val=this.si_id[i].valor;
          if(this.si_id[i].c==1)bndc=true;
        }
      }else{
        if(this.si_id[i].e==e && 
          this.si_id[i]._si==si && 
          this.si_id[i]._id==id && 
          this.si_id[i].responsable==this.duenio_id){
          val=this.si_id[i].valor;
          if(this.si_id[i].c==1)bndc=true;
        }
      }
      
    }
    if(e==5){
      return val;
    }
    if(bndc==true){
      return true;
    }else{
      return false;
    }    
  }
  hk_v:Boolean=false;
  gdasa2(){
    this.loading=true;
    if(this.duenio_id==0){
      swal.fire('!Please select a level and a Responsible from the list!', '', 'warning');
      return;
    }
    //--esquina 1/2/3/4
    //si superior/inferior
    //id izquierda/derecha
    let postData = {
      id_hk:this.id_hk,
      e:this._e,
      si:this._si,
      id:this._id,
      c:0,
      valor:this.type_hk,
      nivel:this.nivel,
      responsable:this.duenio_id
    }
    //console.log(postData);
      this.authService.service("/api/ins_r_hk",postData)
      .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        //swal.fire('¡ok!', '', 'success');
        this.lsr_hk();
        this.cpa2.nativeElement.click();
        this.loading=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta 2!', '', 'error');
          this.loading=false;
      });    

  }
  _c_;
  gdasa(e,si,id,c){
    if(this.duenio_id==0){
      swal.fire('¡falta responsable!', '', 'error');
      return;
    }
    this.loading=true;
    let postData = {
      id_hk:this.id_hk,
      e:e,
      si:si,
      id:id,
      c:Number(c),
      valor:"",
      nivel:Number(this.nivel),
      responsable:Number(this.duenio_id)
    }
    this._c_=Number(c);
    this._id=id;
    this._si=si;
    this._e=e;
      //console.log(postData);
      this.authService.service("/api/ins_r_hk",postData)
      .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        //swal.fire('¡ok!', '', 'success');
        var nid=data.insertId;
        var bndi=false;
        for(var i=0;i<this.si_id.length;i++){
          if(this.si_id[i].e==this._e && 
            this.si_id[i]._si==this._si && 
            this.si_id[i]._id==this._id && 
            this.si_id[i].nivel==this.nivel &&
            this.si_id[i].responsable==this.duenio_id
            ){
            this.si_id[i].c=Number(this._c_);
            bndi=true;
          }
        }
        if(bndi==false){
          this.si_id.push({_id:this._id,e:this._e,_si:this._si,c:Number(this._c_),responsable:this.duenio_id});
        }
        this.loading=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          //console.log(de)
          this.loading=false;
          swal.fire('¡Información incorrecta!', '', 'error');
      });    

  }
  btn_racsi=true;
  fmt_hk(t){
      localStorage.setItem("t_hk",t);
      localStorage.setItem("nivel",this.nivel.toString());
      localStorage.setItem("duenio_id",this.duenio_id.toString());
      localStorage.setItem("duenio",this.duenio.toString());
      localStorage.setItem("fecha",this.fechk.toString());
      localStorage.setItem("superv",this.fechk.toString());
      localStorage.setItem("id_hk",this.id_hk.toString());
      this.router.navigate([]).then(result => {  window.open('./#/fmt_hk', '_blank'); });          
   
  }
  /* charter */
  itm={
    id:0,
    id_matriz:1,
    nombre:"",
    numero:"",
    objetivo:"",
    facilitador:"",
    patrocinador:"",
    vpmexico:"",
  }
  fechaini;
  fechaestini;
  fechaestfin;
  fechapat;
  fechavp;
  bRegistro: boolean=false;
  ant = []
  txtant = "";
  est = []
  txtest = "";
  ent = []
  txtent = "";
  int;
  lstint = []
  selint;
  equ;
  lstequ = []
  selequ;
  mat = []
  txtmat = "";
  cap = []
  txtcap = "";
  lst;
  id_charter=0;
  data_charter;
  charter(itm){
    this.data_charter=itm.des;
    //var id=localStorage.getItem("id_charter");
    //localStorage.setItem("data_charter",JSON.stringify(itm));
    this.id_charter=itm.id;
    this.ls_charter(itm.id);
    this.bRegistro = true;
    /* this.router.navigate(['/registro']); */
  }
  fmt_charter_pdf(){
    localStorage.setItem("id_charter",this.id_charter.toString())
    localStorage.setItem("tpo","P")
    this.router.navigate([]).then(result => {  window.open('./#/fmtcharter', '_blank'); });          
  }
  fmt_assesment(){
    localStorage.setItem("id_charter",this.id_charter.toString())
    localStorage.setItem("tpo","X")
    this.router.navigate([]).then(result => {  window.open('./#/fmtcharter', '_blank'); });          
  }
  ls_charter(id){
    this.loading = true;          
    var sqry;
    sqry = " select" +
           " id, id_matriz, nombre, numero, objetivo, facilitador, patrocinador, vpmexico, fechaini," +
           " fechaestini,fechaestfin,fechapat,fechavp" +
           " from tblcharter_cha" +
           " where id_matriz = " +id +
           " order by nombre";
    this.loading =  true;
    //console.log(sqry)
    this.authService.ejecuta1(sqry)
    .then(
      data  => {    
       
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        //console.log(res);    
        if (res.length!=0){
          this.nvocha(res[0].id,data[0])
        }else{
          this.nvocha(0,null)
        }            
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }


  ls_integrantes(){    
    this.loading = true;          
    var sqry;
    sqry = " select" +
           " tblpersona_tl.id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo" +
           " from tblpersona_tl" +
           " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
           " where tblpersona_tl.id_cliente="+localStorage.getItem("id_cliente")+
           " order by nombre";
    this.loading =  true;

    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;                        
        this.int = data;
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  ls_equipo(){    
    this.loading = true;          
    var sqry;
 
           sqry = " select" +
           " tblpersona_tl.id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo as job" +
           " from tblpersona_tl" +
           " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
           " where tblpersona_tl.id_cliente="+localStorage.getItem("id_cliente")+
           " order by nombre";
    this.loading =  true;

    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;                        
        this.equ = data;
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }
  
  nvoant(){
    if (this.txtant == ""){
      swal.fire("Proporcine el antecedente","","warning");
      return;
    }
    this.ant.push({ 
      id:  0, 
      idx: this.ant.length+1,
      nombre: this.txtant,      
      nombre1: this.txtant,      
      edita: false
    });
    this.txtant = "";
  }
  ediant(itm){    
    for (let i = 0; i < this.ant.length; i++) {
      this.ant[i].edita = false;
    }
    this.ant[itm.idx-1].edita = true;
  }
  canant(itm){
    this.ant[itm.idx-1].nombre1 = this.ant[itm.idx-1].nombre;
    this.ant[itm.idx-1].edita = false;
  }
  guaant(itm){
    if (this.ant[itm.idx-1].nombre1 == ""){
      swal.fire("Proporcine el antecedente","","warning");
      return;
    }
    this.ant[itm.idx-1].nombre = this.ant[itm.idx-1].nombre1;
    this.ant[itm.idx-1].edita = false;
  }
  eliant(itm){
    var objIndex = this.ant.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.ant.splice(objIndex, 1) 
    for (let i = 0; i < this.ant.length; i++) {
      this.ant[i].idx = i+1;
    }
  }

  nvoest(){
    if (this.txtest == ""){
      swal.fire("Proporcine la estrategia","","warning");
      return;
    }
    this.est.push({ 
      id:  0, 
      idx: this.est.length+1,
      nombre: this.txtest,      
      nombre1: this.txtest,      
      edita: false
    });
    this.txtest = "";
  }
  ediest(itm){
    for (let i = 0; i < this.est.length; i++) {
      this.est[i].edita = false;
    }
    this.est[itm.idx-1].edita = true;
  }
  canest(itm){
    this.est[itm.idx-1].nombre1 = this.est[itm.idx-1].nombre;
    this.est[itm.idx-1].edita = false;
  }
  guaest(itm){
    if (this.est[itm.idx-1].nombre1 == ""){
      swal.fire("Proporcine la estrategia","","warning");
      return;
    }
    this.est[itm.idx-1].nombre = this.est[itm.idx-1].nombre1;
    this.est[itm.idx-1].edita = false;
  }
  eliest(itm){
    var objIndex = this.est.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.est.splice(objIndex, 1) 
    for (let i = 0; i < this.est.length; i++) {
      this.est[i].idx = i+1;
    }
  }

  nvoent(){
    if (this.txtent == ""){
      swal.fire("Proporcine el entregable","","warning");
      return;
    }
    this.ent.push({ 
      id:  0, 
      idx: this.ent.length+1,
      nombre: this.txtent,      
      nombre1: this.txtent,      
      edita: false
    });
    this.txtent = "";
  }
  edient(itm){
    for (let i = 0; i < this.ent.length; i++) {
      this.ent[i].edita = false;
    }
    this.ent[itm.idx-1].edita = true;
  }
  canent(itm){
    this.ent[itm.idx-1].nombre1 = this.ent[itm.idx-1].nombre;
    this.ent[itm.idx-1].edita = false;
  }
  guaent(itm){
    if (this.ent[itm.idx-1].nombre1 == ""){
      swal.fire("Proporcine el entregable","","warning");
      return;
    }
    this.ent[itm.idx-1].nombre = this.ent[itm.idx-1].nombre1;
    this.ent[itm.idx-1].edita = false;
  }
  elient(itm){
    var objIndex = this.ent.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.ent.splice(objIndex, 1) 
    for (let i = 0; i < this.ent.length; i++) {
      this.ent[i].idx = i+1;
    }
  }

  nvoint(){
    if (this.selint == undefined){
      swal.fire("Seleccione el integrante","","warning");
      return;
    }
    this.lstint.push({ 
      id:  this.selint.id, 
      idx: this.lstint.length+1,
      nombre: this.selint.nombre,      
      nombre1: this.selint.nombre,      
      titulo: this.selint.titulo,      
      edita: false
    });    
    this.selint = null;
    this.selint = undefined;
  }
  ediint(itm){
    for (let i = 0; i < this.lstint.length; i++) {
      this.lstint[i].edita = false;
    }
    this.lstint[itm.idx-1].edita = true;    
  }
  canint(itm){    
    this.selint = null;
    this.selint = undefined;
    this.lstint[itm.idx-1].edita = false;
  }
  guaint(itm){
    if (this.selint == undefined){
      swal.fire("Seleccione el integrante","","warning");
      return;
    }
    this.lstint[itm.idx-1].id = this.selint.id;
    this.lstint[itm.idx-1].nombre = this.selint.nombre;
    this.lstint[itm.idx-1].nombre1 = this.selint.nombre;
    this.lstint[itm.idx-1].titulo = this.selint.titulo;
    this.lstint[itm.idx-1].edita = false;
    this.selint = null;
    this.selint = undefined;
  }
  eliint(itm){
    var objIndex = this.lstint.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.lstint.splice(objIndex, 1) 
    for (let i = 0; i < this.lstint.length; i++) {
      this.lstint[i].idx = i+1;
    }
  }

  //Equipo de soporte
  nvoequ(){
    if (this.selequ == undefined){
      swal.fire("Seleccione el equipo","","warning");
      return;
    }
    this.lstequ.push({ 
      id:  this.selequ.id, 
      idx: this.lstequ.length+1,
      nombre: this.selequ.nombre,      
      nombre1: this.selequ.nombre,      
      job: this.selequ.job,      
      edita: false
    });    
    this.selequ = null;
    this.selequ = undefined;
  }
  ediequ(itm){
    for (let i = 0; i < this.lstequ.length; i++) {
      this.lstequ[i].edita = false;
    }
    this.lstequ[itm.idx-1].edita = true;    
  }
  canequ(itm){    
    this.selequ = null;
    this.selequ = undefined;
    this.lstequ[itm.idx-1].edita = false;
  }
  guaequ(itm){
    if (this.selequ == undefined){
      swal.fire("Seleccione el equipo","","warning");
      return;
    }
    this.lstequ[itm.idx-1].id = this.selequ.id;
    this.lstequ[itm.idx-1].nombre = this.selequ.nombre;
    this.lstequ[itm.idx-1].nombre1 = this.selequ.nombre;
    this.lstequ[itm.idx-1].job = this.selequ.job;
    this.lstequ[itm.idx-1].edita = false;
    this.selequ = null;
    this.selequ = undefined;
  }
  eliequ(itm){
    var objIndex = this.lstequ.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.lstequ.splice(objIndex, 1) 
    for (let i = 0; i < this.lstequ.length; i++) {
      this.lstequ[i].idx = i+1;
    }
  }


  //Materiales
  nvomat(){
    if (this.txtmat == ""){
      swal.fire("Proporcine el material","","warning");
      return;
    }
    this.mat.push({ 
      id:  0, 
      idx: this.mat.length+1,
      nombre: this.txtmat,      
      nombre1: this.txtmat,      
      edita: false
    });
    this.txtmat = "";
  }
  edimat(itm){
    for (let i = 0; i < this.mat.length; i++) {
      this.mat[i].edita = false;
    }
    this.mat[itm.idx-1].edita = true;
  }
  canmat(itm){
    this.mat[itm.idx-1].nombre1 = this.mat[itm.idx-1].nombre;
    this.mat[itm.idx-1].edita = false;
  }
  guamat(itm){
    if (this.mat[itm.idx-1].nombre1 == ""){
      swal.fire("Proporcine el material","","warning");
      return;
    }
    this.mat[itm.idx-1].nombre = this.mat[itm.idx-1].nombre1;
    this.mat[itm.idx-1].edita = false;
  }
  elimat(itm){
    var objIndex = this.mat.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.mat.splice(objIndex, 1) 
    for (let i = 0; i < this.mat.length; i++) {
      this.mat[i].idx = i+1;
    }
  }

  //Entrenamiento
  nvocap(){
    if (this.txtcap == ""){
      swal.fire("Proporcine el entrenamiento","","warning");
      return;
    }
    this.cap.push({ 
      id:  0, 
      idx: this.cap.length+1,
      nombre: this.txtcap,      
      nombre1: this.txtcap,      
      edita: false
    });
    this.txtcap = "";
  }
  edicap(itm){
    for (let i = 0; i < this.cap.length; i++) {
      this.cap[i].edita = false;
    }
    this.cap[itm.idx-1].edita = true;
  }
  cancap(itm){
    this.cap[itm.idx-1].nombre1 = this.cap[itm.idx-1].nombre;
    this.cap[itm.idx-1].edita = false;
  }
  guacap(itm){
    if (this.cap[itm.idx-1].nombre1 == ""){
      swal.fire("Proporcine el entrenamiento","","warning");
      return;
    }
    this.cap[itm.idx-1].nombre = this.cap[itm.idx-1].nombre1;
    this.cap[itm.idx-1].edita = false;
  }
  elicap(itm){
    var objIndex = this.cap.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.cap.splice(objIndex, 1) 
    for (let i = 0; i < this.cap.length; i++) {
      this.cap[i].idx = i+1;
    }
  }

  cancelar(){
    this.router.navigate(['/#/hk']);
  }
  
  guardar(){
    if (this.itm.nombre == ""){    
      swal.fire('Proporcione el titulo del proyecto', '', 'warning');
      return;
    }
    if (this.itm.numero == ""){    
      swal.fire('Proporcione el número del proyecto', '', 'warning');
      return;
    }
    if (this.fechaini == ""){
      swal.fire('Proporcione la fecha de inicio', '', 'warning');
      return;
    }
    if (this.ant.length == 0){
      swal.fire('Proporcione por lo menos un antecedente', '', 'warning');
      return;
    }
    if (this.itm.objetivo == ""){ 
      swal.fire('Proporcione el objetivo', '', 'warning');
      return;
    }
    if (this.est.length == 0){
      swal.fire('Proporcione por lo menos una estrategia', '', 'warning');
      return;
    }
    if (this.ent.length == 0){
      swal.fire('Proporcione por lo menos un entregable', '', 'warning');
      return;
    }
    if (this.fechaestini == ""){
      swal.fire('Proporcione la fecha de inicio de la estrategia', '', 'warning');
      return;
    }
    if (this.fechaestfin == ""){
      swal.fire('Proporcione la fecha de cierre de la estrategia', '', 'warning');
      return;
    }
    if (this.int.length == 0){
      swal.fire('Proporcione por lo menos un integrante de equipo', '', 'warning');
      return;
    }
    if (this.equ.length == 0){
      swal.fire('Proporcione por lo menos un equipo de soporte', '', 'warning');
      return;
    }
    if (this.mat.length == 0){
      swal.fire('Proporcione por lo menos un material', '', 'warning');
      return;
    }
    if (this.cap.length == 0){
      swal.fire('Proporcione por lo menos un entrenamiento', '', 'warning');
      return;
    }
    if (this.itm.facilitador == ""){ 
      swal.fire('Proporcione el facilitador', '', 'warning');
      return;
    }
    if (this.itm.patrocinador == ""){ 
      swal.fire('Proporcione el patrocinador', '', 'warning');
      return;
    }
    if (this.itm.vpmexico == ""){ 
      swal.fire('Proporcione el VP México', '', 'warning');
      return;
    }
    if (this.fechapat == ""){
      swal.fire('Proporcione la fecha de patrocinador', '', 'warning');
      return;
    }
    if (this.fechavp == ""){
      swal.fire('Proporcione la fecha de VP México', '', 'warning');
      return;
    }
    
    var sqry;
    
    sqry = " call spinsupd_tblcharter_cha (" + 
            //this.itm.id_matriz + ",'" +
            this.id_charter + ",'" +
            this.itm.nombre  + "','" +
            this.itm.numero  + "','" +
            this.itm.objetivo  + "','" +
            this.itm.facilitador  + "','" +
            this.itm.patrocinador  + "','" +
            this.itm.vpmexico  + "','" +
            this.fechaini  + "','" +
            this.fechaestini  + "','" +
            this.fechaestfin  + "','" +
            this.fechapat  + "','" +
            this.fechavp  + "'," +
            this.itm.id + ")";
    
    this.loading =  true;                                
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        if (res.length!=0){
          
          
          for (let i = 0; i < this.ant.length; i++) {
            sqry = " insert into tblantecedente_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.ant[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                swal.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.est.length; i++) {
            sqry = " insert into tblestrategia_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.est[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                swal.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.ent.length; i++) {
            sqry = " insert into tblentregable_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.ent[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                swal.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.lstint.length; i++) {
            sqry = " insert into tblintegrante_cha (id_charter,id_personal) values (" + 
                    res[0][0].id + "," +
                    this.lstint[i].id + ")";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                swal.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.lstequ.length; i++) {
            sqry = " insert into tblequipo_cha (id_charter,id_equipo) values (" + 
                    res[0][0].id + "," +
                    this.lstequ[i].id + ")";                    
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                swal.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.mat.length; i++) {
            sqry = " insert into tblmaterial_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.mat[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                swal.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.cap.length; i++) {
            sqry = " insert into tblentrenamiento_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.cap[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                swal.fire('Datos incorrectos', '', 'error');
            });            
          }
          

        }
        this.loading =  false;      
        swal.fire({ icon: "success", title: "Registro generado", showConfirmButton: false, timer: 1000 });
        //this.bRegistro= false;          
        this.router.navigate(['/#/hk']);
        this.cpa22.nativeElement.click();
        //this.ls_charter();                
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });

  }


  async nvocha(id,itm){
    this.bRegistro = true;

    this.ant = [];
    this.txtant = "";
    this.est = [];
    this.txtest = "";
    this.ent = [];
    this.txtent = "";

    this.lstint = [];
    this.selint = null;
    this.selint = undefined;

    this.lstequ = [];
    this.selequ = null;
    this.selequ = undefined;

    this.mat = [];
    this.txtmat = "";

    this.cap = [];
    this.txtcap = "";   

    this.ls_integrantes();
    this.ls_equipo();
    //console.log("id:"+id);
    if (id == 0){
      
      //console.log("--");
      //console.log(data_charter);
      this.itm.id = 0;
      this.itm.id_matriz = Number(id);      
      //console.log("data_charter")
      //console.log(this.data_charter);
      try {
        
        
        this.itm.nombre = this.data_charter;  
      } catch (error) {
        this.itm.nombre = "";
      }

      
      this.itm.numero = "";
      this.itm.objetivo = "";
      
      var objIndex = this.org.findIndex(((itm1 :any) => itm1.id_role == this.duenio_id));    
      this.itm.facilitador = this.org[objIndex].persona;
      
      this.itm.vpmexico = "";

      //Obtener el patrocinador
      var sqry;
      var id1 = 0;
      if (this.nivel == 1){
        id1 = this.org[0].id_role;
      }else{
        id1 = this.org[0].idarea1;
      }
      var postData = {
        id : id1
      }
      await this.authService.service("/api/get_jefe",postData)
      .then(
        data => {
          this.loading=false;
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this.itm.patrocinador = res[0].nombre +" " + res[0].apaterno +" " + res[0].amaterno;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;        
      });

      let dt = moment(new Date(), 'DD-MM-YYYY');
      this.fechaini = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      this.fechaestini = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      this.fechaestfin = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      this.fechapat = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      this.fechavp = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
    }else {      
      this.itm.id = itm.id;
      this.itm.id_matriz = itm.id_matriz;  
      this.itm.nombre = itm.nombre;  
      this.itm.numero = itm.numero;  
      this.itm.objetivo = itm.objetivo;  
      this.itm.facilitador = itm.facilitador;  
      this.itm.patrocinador = itm.patrocinador;  
      this.itm.vpmexico = itm.vpmexico;  
      
      let dt = moment(new Date(itm.fechaini), 'DD-MM-YYYY');
      this.fechaini = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      dt = moment(new Date(itm.fechaestini), 'DD-MM-YYYY');
      this.fechaestini = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      dt = moment(new Date(itm.fechaestfin), 'DD-MM-YYYY');
      this.fechaestfin = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      dt = moment(new Date(itm.fechapat), 'DD-MM-YYYY');
      this.fechapat = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      dt = moment(new Date(itm.fechavp), 'DD-MM-YYYY');
      this.fechavp = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')

      this.loading = true;          
      var sqry;
      sqry = " select" +
             " id, nombre" +
             " from tblantecedente_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      //console.log(sqry);
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _ant = [];    
            for(var i = 0; i < res.length;i++){
              _ant.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.ant = _ant;
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblestrategia_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _est = [];    
            for(var i = 0; i < res.length;i++){
              _est.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.est = _est;
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblentregable_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _ent = [];    
            for(var i = 0; i < res.length;i++){
              _ent.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.ent = _ent;
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblmaterial_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _mat = [];    
            for(var i = 0; i < res.length;i++){
              _mat.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.mat = _mat;
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblentrenamiento_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _cap = [];    
            for(var i = 0; i < res.length;i++){
              _cap.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.cap = _cap;
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" + 
            " id_personal as id,nombre, titulo" + 
            " from tblintegrante_cha,tblpersonal_cha" + 
            " where tblintegrante_cha.id_personal = tblpersonal_cha.id" + 
            " and id_charter = " + itm.id +
            " order by nombre";
      
            sqry = " select" + 
            " id_personal as id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo " + 
            " from tblintegrante_cha,tblpersona_tl" +             
           " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
            " where tblintegrante_cha.id_personal = tblpersona_tl.id" + 
            " and id_charter = " + itm.id +
            " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _int = [];    
            for(var i = 0; i < res.length;i++){
              _int.push({ 
                id:  res[i].id, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                titulo: res[i].titulo,      
                edita: false
              });   
            }
          }
          this.lstint = _int;
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
   
      sqry = " select" + 
             " id_equipo as id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo as job" + 
             " from tblequipo_cha,tblpersona_tl" +              
           " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
             " where tblequipo_cha.id_equipo = tblpersona_tl.id" + 
             " and id_charter = " + itm.id +
             " order by nombre";

      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _equ = [];    
            for(var i = 0; i < res.length;i++){
              _equ.push({ 
                id:  res[i].id, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                job: res[i].job,      
                edita: false
              });   
            }
          }
          this.lstequ = _equ;
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });

    }

  }

    
  /* charter */
/* 2o nivel */

upd_niv_test(){
  for(var i=0;i<this.evl.length;i++){
    if(Number(this.evl[i].lado)==5 && this.evl[i].nivel==1){
      //console.log(this.evl[i]);   
    }    
  } 
}

/* 2o nivel */


/* Generar Despliegue */
async ls_gendespliegue2(){
  if (window.confirm("¿Desea generar el despliegue?")) {
    this.loading = true;
    var sqry = "";
    sqry = " select * from tblevl_hk"+
           " where id_hk = " + this.id_hk +
           " and estado = 'A' and lado = 5"+
           " and id_ant = 464" ; 
    var data = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
      this.loading = false;
      swal.fire('Datos incorrectos', '', 'error');
      return;
    });      
    if (data == undefined){    
      this.loading = false;
      swal.fire('Datos incorrectos', '', 'error',);
      return;
    }
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);  
    for (let i = 0; i<res.length; i++ ){    
      var niv = Number(res[i].nivel);
      niv = niv + 1;
      var id_ant = res[i].id_ant;
      var responsable = res[i].responsable;
      var ires = 0;

      var nom = "";

      if (id_ant != 0){
        ires = id_ant;
        nom = await this.get_nombre1(ires);
      }else{
        ires = responsable;
        nom = res[i].nombre;
      }
      sqry = " call spins_tblhk ("+
            this.id_cliente + ",'" +
            "hk_niv_" + niv + "_("+this.hkt+"-"+ nom +")"+ "'," +
            this.id_usuario + "," +
            niv + "," +
            ires + ",'"+
            res[i].nombre + "'," +
            this.id_hk + ")";            
            
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat1 = JSON.stringify(data1);
      var res1 = JSON.parse(dat1);  
      
      var id = res1[0][0].id

      /* De 1 a 4 */
      sqry = " insert into tblevl_hk (id_hk,nombre,lado,estado,id_ant,nivel,responsable,idx,id_ant1)"+
             " select "+ id+ ",nombre,4,'A',id_ant,"+niv+",responsable,idx,id"+
             " from tblevl_hk where id_hk = "+this.id_hk+" and estado = 'A' and lado = 1";
      console.log(sqry)
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      
      /* De 2 a 1 */
      sqry = " insert into tblevl_hk (id_hk,nombre,lado,estado,id_ant,nivel,responsable,idx,id_ant1)"+
             " select "+ id+ ",nombre,1,'A',id_ant,"+niv+",responsable,idx,id"+
             " from tblevl_hk where id_hk = "+this.id_hk+" and estado = 'A' and lado = 2";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }

      /* De 4 a 3 */
      sqry = " insert into tblevl_hk (id_hk,nombre,lado,estado,id_ant,nivel,responsable,idx,id_ant1)"+
             " select "+ id+ ",nombre,3,'A',id_ant,"+niv+",responsable,idx,id"+
             " from tblevl_hk where id_hk = "+this.id_hk+" and estado = 'A' and lado = 4";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }


      /*  ARRIBA VS IZQUIERDA	 PARA  ABAJO VS IZQUIERDA  */
      sqry = " select * from tblr_hk where id_hk = " +  this.id_hk + " and e = 1";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat1 = JSON.stringify(data1);
      var res1 = JSON.parse(dat1);  
      for (let j = 0 ; j < res1.length; j++){
        
        //Se inserta como 4 y se obtiene el nuevo id para _si
        sqry = " select id from tblevl_hk where id_ant1 =" + res1[j]._si;        
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);                  
        var _id = res2[0].id;


        //Se inserta como 3 y se obtiene el nuevo id para _di
        sqry = " select id from tblevl_hk where id_ant1 =" + res1[j]._id;                
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos3', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos4', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);                  
        var _si = res2[0].id;
        
        sqry = " insert into tblr_hk (id_hk,e,_si,_id,c,valor,nivel,responsable) values ("+
               id + "," +
               3 + "," +
               _si + "," +
               _id + "," +
               res1[j].c + ",'" +
               "" + "'," +
               niv + "," +
               res1[j].responsable + ")";
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
      }
      

      /*  ARRIBA VS DERECHA	 PARA  ARRIBA VS IZQUIERDA  */
      sqry = " select * from tblr_hk where id_hk = " +  this.id_hk + " and e = 2";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat1 = JSON.stringify(data1);
      var res1 = JSON.parse(dat1);  
      for (let j = 0 ; j < res1.length; j++){
        //Se inserta como 1 y se obtiene el nuevo id para _id1        
        sqry = " select id from tblevl_hk where id_ant1 =" + res1[j]._id;
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);          
        var _id1 = res2[0].id;

        
        //Se inserta como 4 y se obtiene el nuevo id para _si1
        sqry = " select id from tblevl_hk where id_ant1 =" + res1[j]._si;
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);          
        var _si1 = res2[0].id;
        
        sqry = " insert into tblr_hk (id_hk,e,_si,_id,c,valor,nivel,responsable) values ("+
               id + "," +
               1 + "," +
               _id1 + "," +
               _si1 + "," +
               res1[j].c + ",'" +
               "" + "'," +
               niv + "," +
               res1[j].responsable + ")";
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }

      }

    }
    this.loading = false;
    swal.fire({ icon: "success", html: "<h3>Información registrada</h3><h5>Finalizando, favor espere...</h5>", showConfirmButton: false, timer: 1000 });
  
    this.ls_hk();
  }
}

/*********************************************************************************/
async ls_gendespliegue1(){
  if (window.confirm("¿Desea generar el despliegue?")) {
    this.loading = true;

    var sqry = "";
    sqry = " select * from tblevl_hk"+
           " where id_hk = " + this.id_hk +
           " and estado = 'A' and lado = 5";
    var data = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
      this.loading = false;
      swal.fire('Datos incorrectos', '', 'error');
      return;
    });      
    if (data == undefined){    
      this.loading = false;
      swal.fire('Datos incorrectos', '', 'error',);
      return;
    }
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);  
    for (let i = 0; i<res.length; i++ ){
      var niv = Number(res[i].nivel);
      niv = niv + 1;
      var id_ant = res[i].id_ant;
      var responsable = res[i].responsable;
      var ires = 0;

      var nom = "";

      if (id_ant != 0){
        ires = id_ant;
        nom = await this.get_nombre1(ires);
      }else{
        ires = responsable;
        nom = res[i].nombre;
      }
      
      
      sqry = " call spins_tblhk ("+
            this.id_cliente + ",'" +
            "hk_niv_" + niv + "_("+this.hkt+"-"+ nom +")"+ "'," +
            this.id_usuario + "," +
            niv + "," +
            ires + ",'"+
            res[i].nombre + "'," +
            this.id_hk + ")";            
            
        var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat1 = JSON.stringify(data1);
      var res1 = JSON.parse(dat1);  
      

      var id = res1[0][0].id





      /*  ARRIBA VS IZQUIERDA	 PARA  ABAJO VS IZQUIERDA  */
      sqry = " select * from tblr_hk where id_hk = " +  this.id_hk + " and e = 1";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat1 = JSON.stringify(data1);
      var res1 = JSON.parse(dat1);  
      for (let j = 0 ; j < res1.length; j++){

        //Se inserta como 4 y se obtiene el nuevo id para _si
        sqry = " select nombre, id_ant, responsable from tblevl_hk where id =" + res1[j]._si;        
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);  
        
        var _nombre = res2[0].nombre;
        var _id_ant = res2[0].id_ant;
        var _responsable = res2[0].responsable;

        sqry = " insert into tblevl_hk (id_hk,nombre,lado,estado,id_ant,nivel,responsable,idx) values (" +
              id + ",'" +
              _nombre + "'," +
              4 + ",'" +
              "A" + "'," +
              _id_ant + "," +
              niv + "," +
              _responsable + "," +
              0  + ")";
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        sqry = " select max(id) from tblevl_hk where id_hk = " + id + " and lado = 4 and nivel = " + niv;
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos1', '', 'error');
          return;
        });      
        if (data2 == undefined){
          this.loading = false;    
          swal.fire('Datos incorrectos2', '', 'error',);
          return;
        }   
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);  
        var _id = res[0].id;



        
        //Se inserta como 3 y se obtiene el nuevo id para _di
        sqry = " select nombre, id_ant, responsable from tblevl_hk where id =" + res1[j]._id;                
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos3', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos4', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);  
        
        var _nombre = res2[0].nombre;
        var _id_ant = res2[0].id_ant;
        var _responsable = res2[0].responsable;

        sqry = " insert into tblevl_hk (id_hk,nombre,lado,estado,id_ant,nivel,responsable,idx) values (" +
              id + ",'" +
              _nombre + "'," +
              3 + ",'" +
              "A" + "'," +
              _id_ant + "," +
              niv + "," +
              _responsable + "," +
              0  + ")";
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos5', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos6', '', 'error',);
          return;
        }
        sqry = " select max(id) from tblevl_hk where id_hk = " + id + " and lado = 3 and nivel = " + niv;
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos7', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos8', '', 'error',);
          return;
        }   
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);  
        var _si = res[0].id;



        sqry = " insert into tblr_hk (id_hk,e,_si,_id,c,valor,nivel,responsable) values ("+
               id + "," +
               3 + "," +
               _si + "," +
               _id + "," +
               res1[j].c + ",'" +
               "" + "'," +
               niv + "," +
               res1[j].responsable + ")";
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
      }


      /*  ARRIBA VS DERECHA	 PARA  ARRIBA VS IZQUIERDA  */
      sqry = " select * from tblr_hk where id_hk = " +  this.id_hk + " and e = 2";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat1 = JSON.stringify(data1);
      var res1 = JSON.parse(dat1);  
      for (let j = 0 ; j < res1.length; j++){

        
        //Se inserta como 1 y se obtiene el nuevo id para _si        
        sqry = " select nombre, id_ant, responsable from tblevl_hk where id =" + res1[j]._id;
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);  
        
        var _nombre = res2[0].nombre;
        var _id_ant = res2[0].id_ant;
        var _responsable = res2[0].responsable;

        sqry = " insert into tblevl_hk (id_hk,nombre,lado,estado,id_ant,nivel,responsable,idx) values (" +
              id + ",'" +
              _nombre + "'," +
              1 + ",'" +
              "A" + "'," +
              _id_ant + "," +
              niv + "," +
              _responsable + "," +
              0  + ")";
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        sqry = " select max(id) from tblevl_hk where id_hk = " + id + " and lado = 1 and nivel = " + niv;
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }   
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);  
        var _id1 = res[0].id;


        
        /* este ya no es necesario ya lo tenemos de arriba */
        sqry = " select nombre, id_ant, responsable from tblevl_hk where id =" + res1[j]._di;
        //Se inserta como 4 y se obtiene el nuevo id para _di


        sqry = " insert into tblr_hk (id_hk,e,_si,_id,c,valor,nivel,responsable) values ("+
               id + "," +
               1 + "," +
               _si + "," +
               _id1 + "," +
               res1[j].c + ",'" +
               "" + "'," +
               niv + "," +
               res1[j].responsable + ")";
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
      }

    }
  
    this.loading = false;
    swal.fire({ icon: "success", html: "<h3>Información registrada</h3><h5>Finalizando, favor espere...</h5>", showConfirmButton: false, timer: 1000 });
  
    this.ls_hk();
    this.bnd_list=true;
  }
}


/* Generar Despliegue */
async ls_gendespliegue(){
  if (window.confirm("¿Desea generar el despliegue?")) {
    this.loading = true;
    var sqry = "";
    sqry = " select * from tblevl_hk"+
           " where id_hk = " + this.id_hk +
           " and estado = 'A' and lado = 5"; 
    var data = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
      this.loading = false;
      swal.fire('Datos incorrectos', '', 'error');
      return;
    });      
    if (data == undefined){    
      this.loading = false;
      swal.fire('Datos incorrectos', '', 'error',);
      return;
    }
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);  
    for (let i = 0; i<res.length; i++ ){    
      var niv = Number(res[i].nivel);
      niv = niv + 1;
      var id_evl_lad5 = res[i].id;
      var id_ant = res[i].id_ant;
      var responsable = res[i].responsable;
      var ires = 0;

      var nom = "";

      if (id_ant != 0){
        ires = id_ant;
        nom = await this.get_nombre1(ires);
      }else{
        ires = responsable;
        nom = res[i].nombre;
      }
      sqry = " call spins_tblhk ("+
            this.id_cliente + ",'" +
            "hk_niv_" + niv + "_("+this.hkt+"-"+ nom +")"+ "'," +
            this.id_usuario + "," +
            niv + "," +
            ires + ",'"+
            res[i].nombre + "'," +
            this.id_hk + ")";            
            
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat1 = JSON.stringify(data1);
      var res1 = JSON.parse(dat1);  
      
      var id = res1[0][0].id


      /* Sólo insertar los seleccionados R y Rs */
      sqry = " select _si from tblr_hk where id_hk = "+this.id_hk+" and e = 5 and _id = " + id_evl_lad5;
      var data3 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data3 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat3 = JSON.stringify(data3);
      var res3 = JSON.parse(dat3);  
      var _ssi="";
      for (let k = 0 ; k < res3.length; k++){
        if (_ssi != ""){
          _ssi = _ssi + ",";
        }
        _ssi = _ssi + res3[k]._si;
      }

      /* De 2 a 1 */
      sqry = " insert into tblevl_hk (id_hk,nombre,lado,estado,id_ant,nivel,responsable,idx,id_ant1)"+
             " select "+ id+ ",nombre,1,'A',id_ant,"+niv+","+ires+",idx,id"+
             " from tblevl_hk where id_hk = "+this.id_hk+" and estado = 'A' and lado = 2";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }


      /* De 1 a 4 */
      sqry = " insert into tblevl_hk (id_hk,nombre,lado,estado,id_ant,nivel,responsable,idx,id_ant1)"+
             " select "+ id+ ",nombre,4,'A',id_ant,"+niv+","+ires+",idx,id"+
             " from tblevl_hk where id_hk = "+this.id_hk+" and estado = 'A' and lado = 1"+
             " and id in (" + _ssi + ")";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
            

      /* De 4 a 3 */
      sqry = " insert into tblevl_hk (id_hk,nombre,lado,estado,id_ant,nivel,responsable,idx,id_ant1)"+
             " select "+ id+ ",nombre,3,'A',id_ant,"+niv+","+ires+",idx,id"+
             " from tblevl_hk where id_hk = "+this.id_hk+" and estado = 'A' and lado = 4";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');      
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }


      /*  ARRIBA VS IZQUIERDA	 PARA  ABAJO VS IZQUIERDA  */
      sqry = " select * from tblr_hk where id_hk = " +  this.id_hk + " and e = 1";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat1 = JSON.stringify(data1);
      var res1 = JSON.parse(dat1);  
      for (let j = 0 ; j < res1.length; j++){
        
        //Se inserta como 4 y se obtiene el nuevo id para _si
        sqry = " select id from tblevl_hk where id_ant1 =" + res1[j]._si;        
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);                  

        if (res2.length>0){
          var _id = res2[0].id;

          //Se inserta como 3 y se obtiene el nuevo id para _di
          sqry = " select id from tblevl_hk where id_ant1 =" + res1[j]._id;                
          var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
            this.loading = false;
            swal.fire('Datos incorrectos3', '', 'error');
            return;
          });      
          if (data2 == undefined){    
            this.loading = false;
            swal.fire('Datos incorrectos4', '', 'error',);
            return;
          }
          var dat2 = JSON.stringify(data2);
          var res2 = JSON.parse(dat2);                  
          var _si = 0;
          try {
            _si = res2[0].id;
          } catch (error) {
            _si = 0;
          }
          
          sqry = " insert into tblr_hk (id_hk,e,_si,_id,c,valor,nivel,responsable) values ("+
                id + "," +
                3 + "," +
                _si + "," +
                _id + "," +
                res1[j].c + ",'" +
                "" + "'," +
                niv + "," +
                ires + ")";
          var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
            this.loading = false;
            swal.fire('Datos incorrectos', '', 'error');
            return;
          });      
          if (data2 == undefined){    
            this.loading = false;
            swal.fire('Datos incorrectos', '', 'error',);
            return;
          }
        }
        
      }
      

      /*  ARRIBA VS DERECHA	 PARA  ARRIBA VS IZQUIERDA  */
      sqry = " select * from tblr_hk where id_hk = " +  this.id_hk + " and e = 2";
      var data1 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error');
        return;
      });      
      if (data1 == undefined){    
        this.loading = false;
        swal.fire('Datos incorrectos', '', 'error',);
        return;
      }
      var dat1 = JSON.stringify(data1);
      var res1 = JSON.parse(dat1);  
      for (let j = 0 ; j < res1.length; j++){
        //Se inserta como 1 y se obtiene el nuevo id para _id1        
        sqry = " select id from tblevl_hk where id_ant1 =" + res1[j]._id;
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);          
        var _id1 = 0;
        try {
          _id1 = res2[0].id;
        } catch (error) {
          _id1 = 0;
        }

        
        //Se inserta como 4 y se obtiene el nuevo id para _si1
        sqry = " select id from tblevl_hk where id_ant1 =" + res1[j]._si;
        var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error');
          return;
        });      
        if (data2 == undefined){    
          this.loading = false;
          swal.fire('Datos incorrectos', '', 'error',);
          return;
        }
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2);     
        
        if (res2.length>0){
          var _si1 = res2[0].id;        
          sqry = " insert into tblr_hk (id_hk,e,_si,_id,c,valor,nivel,responsable) values ("+
                id + "," +
                1 + "," +
                _id1 + "," +
                _si1 + "," +
                res1[j].c + ",'" +
                "" + "'," +
                niv + "," +
                ires + ")";
          var data2 = await this.authService.ejecuta(sqry).toPromise().catch(()=>{        
            this.loading = false;
            swal.fire('Datos incorrectos', '', 'error');
            return;
          });      
          if (data2 == undefined){    
            this.loading = false;
            swal.fire('Datos incorrectos', '', 'error',);
            return;
          }
        }
        

      }

    }
    this.loading = false;
    swal.fire({ icon: "success", html: "<h3>Información registrada</h3><h5>Finalizando, favor espere...</h5>", showConfirmButton: false, timer: 1000 });
  
    this.ls_hk();
  }
}



}
